Ext.define('SA.model.createimport.FileTupleListValidator', {
    constructor(list) {
        this.list = list;
        this.tupleValidators = list.map(tuple => new SA.model.createimport.FileTupleValidator(tuple));
    },

    filter(callback) {
        return this.tupleValidators.filter(callback);
    },

    getValidatorsForInvalidFiles() {
        var hasInvalidFile = validator => validator.hasInvalidFile(),
            getFileSchemaValidator = validator => validator.getFileSchemaValidator();

        return this.tupleValidators.filter(hasInvalidFile).map(getFileSchemaValidator);
    },

    hasDifferentColumnCountsAcrossFiles() {
        var hasReadableFile = validator => validator.hasReadableFile(),
            getColumnCount = validator => validator.getColumnCount(),
            columnCounts = this.filter(hasReadableFile).map(getColumnCount);

        return Ext.Array.unique(columnCounts).length > 1;
    },

    hasDuplicateUnits() {
        var units = this.list.getUnits().filter(unit => !!unit);

        return SA.Array.hasDuplicates(units);
    },

    hasFileWithMoreThanOneUniqueHeaderName() {
        var headerNamesPerFile = this.list.map(tuple => tuple.getHeaderNames()),
            commonNameCount = Ext.Array.intersect(...headerNamesPerFile).length;

        if (this.list.getFileCount() < 2) {
            return false;
        }

        return headerNamesPerFile.some(headerNames => headerNames.length - 1 > commonNameCount);
    },

    hasFileWithoutUnit() {
        return !!this.filter(tuple => tuple.hasFileWithoutUnit()).length;
    },

    hasInvalidTuples() {
        return !!this.filter(tuple => !tuple.isValid()).length;
    },

    hasUnitWithoutFile() {
        return !!this.filter(tuple => tuple.hasUnitWithoutFile()).length;
    },

    isEmpty() {
        return this.list.getTupleCount() === 0;
    },

    isValid() {
        return !this.isEmpty() &&
            !this.hasInvalidTuples() &&
            !this.hasDifferentColumnCountsAcrossFiles() &&
            !this.hasFileWithMoreThanOneUniqueHeaderName() &&
            !this.hasDuplicateUnits();
    }
});